// Central definition of widget groups & types for reuse across configurator & runtime rendering.
export const MAIN_WIDGET_GROUPS = ["Card", "Charts", "Gauge", "Table", "Control", "Map", "Others"];

export const SUB_WIDGET_TYPES = {
  Card: ["Single Value", "Multi Value", "Value Card", "Status Card", "Scheduler Status", "Tag Value Card"],
  Charts: ["Line Chart", "Bar Chart", "Area Chart", "Pie Chart", "Radar Chart", "Doughnut Chart", "Scatter Chart"],
  Gauge: ["Circular Gauge", "Semi Circular Gauge", "Linear Gauge", "Speed Gauge", "Temperature Gauge"],
  Table: ["Timeseries Table"],
  Control: ["Status", "Switch", "Set Value"],
  Map: ["Google Map"],
  Others: ["Sankey Chart", "Funnel", "Mixed Chart", "Treemap", "Linear Progress Bar", "Solar Chart", "BBT", "PQ Events Pie", "AQI Gauge", "Switch Gauge", "Simple Gauge", "Device Donut", "Gateway Donut", "DeviceTable", "TableGateway"],
};

// Flattened list of all sub widget types
export const ALL_WIDGET_TYPES = Object.values(SUB_WIDGET_TYPES).flat();

// Helper to detect if a type belongs to a group
export function groupForType(type) {
  return Object.keys(SUB_WIDGET_TYPES).find(group => SUB_WIDGET_TYPES[group].includes(type)) || null;
}

export function isChartType(type) { return SUB_WIDGET_TYPES.Charts.includes(type) || SUB_WIDGET_TYPES.Others.includes(type); }
export function isGaugeType(type) { return SUB_WIDGET_TYPES.Gauge.includes(type); }
export function isTableType(type) { return SUB_WIDGET_TYPES.Table.includes(type); }
export function isCardType(type) { return SUB_WIDGET_TYPES.Card.includes(type); }
export function isControlType(type) { return SUB_WIDGET_TYPES.Control.includes(type); }
export function isMapType(type) { return SUB_WIDGET_TYPES.Map.includes(type); }
export function isOthersType(type) { return SUB_WIDGET_TYPES.Others.includes(type); }